import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { Component, OnDestroy, OnInit } from '@angular/core';
// @ts-ignore
import { FormsModule } from '@angular/forms';
// @ts-ignore
import { firstValueFrom } from 'rxjs';
import { descreverAcao } from './atividade-acao';
import {
  AtividadeAcessoUsuarioMonitorado,
  AtividadeAcessoAcao,
  SankhyaGatewayService
} from '../../services/sankhya-gateway.service';

@Component({
  selector: 'app-atividade-acessos',
  standalone: true,
  imports: [LoadingIndicatorComponent, CommonModule, FormsModule],
  templateUrl: './atividade-acessos.component.html',
  styleUrl: './atividade-acessos.component.css'
})
export class AtividadeAcessosComponent implements OnInit, OnDestroy {
  readonly descreverAcao = descreverAcao;
  filtro = '';
  carregando = false;
  erro = '';
  usuarios: AtividadeAcessoUsuarioMonitorado[] = [];
  totalUsuarios = 0;
  totalOnline = 0;
  atualizadoEm = '';
  observacao = '';
  readonly tamanhoPagina = 20;
  pagina = 1;
  paginaLog = 1;
  acoes: AtividadeAcessoAcao[] = [];
  selecionado: AtividadeAcessoUsuarioMonitorado | null = null;
  dados = { nome: '', email: '', senha: '', confirmarSenha: '' };
  private destruido = false;
  private requisicaoEmAndamento = false;
  private atualizacaoTimer: ReturnType<typeof setInterval> | null = null;

  constructor(private readonly gateway: SankhyaGatewayService) {}

  async ngOnInit(): Promise<void> {
    await this.carregar();
    if (!this.destruido) this.atualizacaoTimer = setInterval(() => void this.carregar(false), 30000);
  }

  ngOnDestroy(): void {
    this.destruido = true;
    this.dados = { nome: '', email: '', senha: '', confirmarSenha: '' };
    if (this.atualizacaoTimer) clearInterval(this.atualizacaoTimer);
  }

  async carregar(exibirCarregamento = true): Promise<void> {
    if (this.requisicaoEmAndamento) return;
    this.requisicaoEmAndamento = true;
    if (exibirCarregamento) this.carregando = true;
    this.erro = '';

    try {
      const resposta = await firstValueFrom(this.gateway.listarMonitoramentoAtividadeAcessos());
      this.usuarios = Array.isArray(resposta?.usuarios) ? resposta.usuarios : [];
      this.totalUsuarios = Number(resposta?.totalUsuarios ?? this.usuarios.length);
      this.totalOnline = Number(resposta?.totalOnline ?? this.usuarios.filter((usuario) => usuario.online).length);
      this.atualizadoEm = resposta?.atualizadoEm ?? '';
      this.observacao = resposta?.observacao ?? '';
      this.acoes = Array.isArray(resposta?.acoes) ? resposta.acoes : [];
      this.pagina = Math.min(this.pagina, this.totalPaginas);
      this.paginaLog = Math.min(this.paginaLog, this.totalPaginasLog);
      if (this.selecionado) {
        this.selecionado = this.usuarios.find(u => u.usuario === this.selecionado?.usuario)
          ?? { ...this.selecionado, online: false, sessoesAbertas: 0 };
      }
    } catch (e: any) {
      this.erro = e?.error?.detail || e?.message || 'Nao foi possivel atualizar a atividade de acessos.';
    } finally {
      this.carregando = false;
      this.requisicaoEmAndamento = false;
    }
  }

  usuariosFiltrados(): AtividadeAcessoUsuarioMonitorado[] {
    const termo = this.normalizar(this.filtro.trim());
    if (!termo) return this.usuarios;
    return this.usuarios.filter((usuario) => this.normalizar(usuario.usuario).includes(termo));
  }

  private normalizar(valor: string): string {
    return valor.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
  }

  get totalPaginas(): number { return Math.max(1, Math.ceil(this.usuariosFiltrados().length / this.tamanhoPagina)); }
  get usuariosPagina(): AtividadeAcessoUsuarioMonitorado[] {
    return this.usuariosFiltrados().slice((this.pagina - 1) * this.tamanhoPagina, this.pagina * this.tamanhoPagina);
  }
  get acoesFiltradas(): AtividadeAcessoAcao[] {
    return this.acoes.filter(acao => this.selecionado ? acao.usuario === this.selecionado.usuario
      : this.normalizar(acao.usuario).includes(this.normalizar(this.filtro.trim())));
  }
  get totalPaginasLog(): number { return Math.max(1, Math.ceil(this.acoesFiltradas.length / this.tamanhoPagina)); }
  get acoesPagina(): AtividadeAcessoAcao[] {
    return this.acoesFiltradas.slice((this.paginaLog - 1) * this.tamanhoPagina, this.paginaLog * this.tamanhoPagina);
  }
  buscar(): void { this.pagina = 1; this.paginaLog = 1; }
  selecionar(usuario: AtividadeAcessoUsuarioMonitorado): void {
    this.selecionado = usuario;
    this.dados = { nome: '', email: '', senha: '', confirmarSenha: '' };
    this.paginaLog = 1;
  }
  fecharDetalhes(): void {
    this.selecionado = null;
    this.dados = { nome: '', email: '', senha: '', confirmarSenha: '' };
    this.paginaLog = 1;
  }

  formatarDataHora(valor: string): string {
    if (!valor) return '-';
    const data = new Date(valor);
    return Number.isNaN(data.getTime()) ? valor : data.toLocaleString('pt-BR');
  }
}
